// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Faltan variables de entorno de Supabase. Verifica .env');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true },
  realtime: { params: { eventsPerSecond: 10 } },
});

// ============================================================
// HELPERS DE AUTENTICACIÓN
// ============================================================
export const signIn = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  return { data, error };
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  return { error };
};

export const getSession = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
};

// ============================================================
// LISTAS DE AFILIADOS (fase 4.2)
// ============================================================
// Columnas de `afiliados` para las PANTALLAS DE LISTA: todas MENOS `firma_afiliado_base64` y `autorizacion_texto`
// (el panel nunca las usa; juntas pesaban ~1 MB de 2,7 MB con 50 afiliados, 14-oct-2026).
// Si se agrega una columna nueva a `afiliados` y una lista la necesita, hay que añadirla aquí.
export const AFILIADO_COLS_LISTA =
  'id, codigo_qr, nombres, apellidos, cedula, fecha_nacimiento, direccion, peso, estatura, plan, frecuencia, whatsapp, email, foto_url, foto_base64, estado, fecha_inscripcion, fecha_inicio_plan, fecha_vencimiento, fecha_desde_vencido, dia_corte, historial_corte, contrato_generado, carne_generado, notificacion_2dias, notificacion_1dia, notificacion_vencido, periodo_notificacion, autorizacion_datos, autorizacion_fecha, autorizacion_ip, created_at, updated_at, contrato_url, carnet_url, genero, cintura_cm, cuello_cm, cadera_cm, nivel_actividad, objetivo_fitness, bold_link_pago_id, bold_link_pago_url, bold_link_pago_expira, metodo_pago_prometido, monto_mensual_personalizado, documentos_pendientes, bold_link_pago_referencia, tipo_documento, representante_nombre, representante_tipo_documento, representante_documento, representante_parentesco, representante_whatsapp';

// Trae TODAS las filas de una consulta en tandas (Supabase corta cada respuesta en 1000 filas por defecto).
// `armarConsulta` debe devolver una consulta NUEVA con un orden total (usar un desempate por id).
export const traerTodos = async (armarConsulta, tam = 1000) => {
  const filas = [];
  for (let desde = 0; ; desde += tam) {
    const { data, error } = await armarConsulta().range(desde, desde + tam - 1);
    if (error) return { data: null, error };
    filas.push(...(data || []));
    if (!data || data.length < tam) break;
  }
  return { data: filas, error: null };
};

// ============================================================
// HELPERS DE CONFIGURACIÓN
// ============================================================
export const getConfiguracion = async () => {
  const { data, error } = await supabase.from('configuracion').select('*');
  if (error) return {};
  return data.reduce((acc, item) => ({ ...acc, [item.clave]: item.valor }), {});
};
